module.exports = __webpack_public_path__ + "static/media/gif2.b71a49bf.gif";